import { api2 } from './index';

export const getWidgetConfig = (key, params) => api2.post(`v1/widget-config/${key}`, params)
  .then((response) => response.data);
